var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYllwInventory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_2",
    "data-name": "Lager 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1452.79 273.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_2-2",
    "data-name": "Lager 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,220.53h50.17v50.17H0v-50.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.11h50.17v133.8H0V3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.17,136.91h83.62v83.62H50.17v-83.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.8,3.11h133.8v133.8h-133.8V3.11Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M353.87,3.04h44.1v267.65h-44.1V3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.3,3.04h48.66l34.41,173.74h2.47c-1.02-7.35-2.03-16.92-3.04-28.7-1.02-11.79-1.52-21.67-1.52-29.65V3.04h38.97v267.65h-42.2l-41.06-178.88h-2.85c1.14,8.62,2.22,18.69,3.23,30.22,1.01,11.53,1.52,20.53,1.52,26.99v121.66h-38.59V3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.7,3.04h43.53l14.45,138.01c1.27,11.53,2.6,29.15,3.99,52.84h3.23c.88-20.91,2.09-38.52,3.61-52.84l13.69-138.01h41.06l-38.21,267.65h-46.76L556.7,3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.7,3.04h93.14v37.07h-49.99v63.68h40.87v35.55h-40.87v94.29h49.99v37.07h-93.14V3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.1,3.04h48.66l34.41,173.74h2.47c-1.02-7.35-2.03-16.92-3.04-28.7-1.02-11.79-1.52-21.67-1.52-29.65V3.04h38.97v267.65h-42.2l-41.06-178.88h-2.85c1.14,8.62,2.22,18.69,3.23,30.22,1.01,11.53,1.52,20.53,1.52,26.99v121.66h-38.59V3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.75,39.54h-35.36V3.04h115.01v36.5h-34.98v231.15h-44.67V39.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.54,257c-9.88-11.15-14.83-27.12-14.83-47.9V66.15c0-21.16,4.94-37.48,14.83-48.95,9.89-11.47,23.95-17.2,42.2-17.2s32.13,5.73,42.01,17.2c9.89,11.47,14.83,27.79,14.83,48.95v142.95c0,20.66-4.91,36.59-14.73,47.81-9.82,11.22-23.79,16.82-41.92,16.82s-32.51-5.57-42.39-16.73ZM1133.53,231.44c1.96-3.86,2.95-10.1,2.95-18.72V62.16c0-9-.98-15.46-2.95-19.39-1.97-3.93-5.23-5.89-9.79-5.89s-8.05,2-10.07,5.99c-2.03,3.99-3.04,10.43-3.04,19.29v150.55c0,8.62,1.01,14.86,3.04,18.72,2.03,3.87,5.38,5.8,10.07,5.8s7.82-1.93,9.79-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203.96,3.04h56.65c20.4,0,35.67,6.34,45.81,19.01,10.14,12.67,15.21,31.05,15.21,55.13,0,16.22-2.25,29.94-6.75,41.16-4.5,11.21-11.25,19.48-20.24,24.81l31.94,127.55h-45.24l-27.56-120.14h-7.03v120.14h-42.77V3.04ZM1258.51,114.05c6.46,0,11.34-3.04,14.64-9.12,3.29-6.08,4.94-15.65,4.94-28.7s-1.55-22.27-4.66-28.04c-3.11-5.77-7.76-8.65-13.97-8.65h-12.74v74.52h11.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.25,165.19L1325.81,3.04h47.14l12.17,65.39c1.77,9.76,3.36,20.97,4.75,33.65h2.66c1.27-13.56,2.72-24.77,4.37-33.65l12.36-65.39h43.53l-41.25,161.77v105.88h-44.29v-105.5Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYllwInventory);
export default __webpack_public_path__ + "static/media/Yllw_Inventory.1dd7f65e794474e2ed5fc0a11a6397e9.svg";
export { ForwardRef as ReactComponent };